import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const useWebView = () => {
  const router = useRouter();
  const [isWebView, setIsWebView] = useState(false);

  useEffect(() => {
    if (router?.query?.is_mobile === '1') {
      setIsWebView(true);

      sessionStorage.setItem('is_mobile', '1');
    } else if (sessionStorage.getItem('is_mobile') === '1') {
      setIsWebView(true);
    }
  }, [router]);

  return isWebView;
};

export default useWebView;
